class TimingCarousel extends HTMLElement {
  constructor() {
    super();
    this.scroller = this.querySelector('.timing__carousel');
    this.cards = this.querySelectorAll('.timing__carousel-card');
    this.autoplay = this.dataset.autoplay === 'true';
    this.interval = parseInt(this.dataset.interval, 10) || 4000;
    this.resumeDelay = 5000;
    this.timer = null;
    this.resumeTimer = null;
    this.currentIndex = 0;
    this.desktopMq = window.matchMedia('(min-width: 990px)');
    this.reducedMotionMq = window.matchMedia('(prefers-reduced-motion: reduce)');
  }

  connectedCallback() {
    if (!this.scroller || this.cards.length <= 1 || !this.autoplay) return;

    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    this.handleUserInteract = this.handleUserInteract.bind(this);
    this.handleMqChange = this.handleMqChange.bind(this);

    this.addEventListener('touchstart', this.handleUserInteract, { passive: true });
    this.addEventListener('mousedown', this.handleUserInteract, { passive: true });
    this.addEventListener('keydown', this.handleUserInteract);
    this.addEventListener('mouseenter', this.handleUserInteract);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    this.desktopMq.addEventListener('change', this.handleMqChange);
    this.reducedMotionMq.addEventListener('change', this.handleMqChange);

    this.maybeStart();
  }

  disconnectedCallback() {
    this.stop();
    clearTimeout(this.resumeTimer);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    this.desktopMq.removeEventListener('change', this.handleMqChange);
    this.reducedMotionMq.removeEventListener('change', this.handleMqChange);
  }

  maybeStart() {
    if (this.desktopMq.matches) return;
    if (this.reducedMotionMq.matches) return;
    if (document.hidden) return;
    this.start();
  }

  start() {
    this.stop();
    this.timer = setInterval(() => this.next(), this.interval);
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  handleUserInteract() {
    this.stop();
    clearTimeout(this.resumeTimer);
    this.resumeTimer = setTimeout(() => this.maybeStart(), this.resumeDelay);
  }

  handleVisibilityChange() {
    if (document.hidden) {
      this.stop();
    } else {
      this.maybeStart();
    }
  }

  handleMqChange() {
    if (this.desktopMq.matches || this.reducedMotionMq.matches) {
      this.stop();
    } else {
      this.maybeStart();
    }
  }

  next() {
    this.syncIndexFromScroll();
    const nextIndex = (this.currentIndex + 1) % this.cards.length;
    this.scrollToIndex(nextIndex);
    this.currentIndex = nextIndex;
  }

  syncIndexFromScroll() {
    const scrollerRect = this.scroller.getBoundingClientRect();
    let nearest = 0;
    let nearestDist = Infinity;
    this.cards.forEach((card, i) => {
      const dist = Math.abs(card.getBoundingClientRect().left - scrollerRect.left);
      if (dist < nearestDist) {
        nearestDist = dist;
        nearest = i;
      }
    });
    this.currentIndex = nearest;
  }

  scrollToIndex(index) {
    const card = this.cards[index];
    if (!card) return;
    const cardRect = card.getBoundingClientRect();
    const scrollerRect = this.scroller.getBoundingClientRect();
    const targetLeft = this.scroller.scrollLeft + (cardRect.left - scrollerRect.left);
    const isLoopBack = index === 0 && this.currentIndex === this.cards.length - 1;
    this.scroller.scrollTo({
      left: targetLeft,
      behavior: isLoopBack ? 'auto' : 'smooth',
    });
  }
}

if (!customElements.get('timing-carousel')) {
  customElements.define('timing-carousel', TimingCarousel);
}
